import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 23.6rem;
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: ${({ theme }) => theme.styleGuide.shadows.overlay};
  }
`;

export const Illustration = styled.div`
  margin-bottom: 2rem;

  svg {
    height: 9.6rem;
  }
`;

export const Title = styled.h3`
  width: 100%;
  font-size: 2.4rem;
  font-weight: 600;
  line-height: 3.1rem;
  margin-bottom: 0.8rem;
  padding: 0 0.5rem;
  text-align: center;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ theme }) => theme.media.sm`
    font-size: 1.6rem;
    line-height: 2rem;
  `}
`;

export const SubTitle = styled.h4`
  font-size: 2rem;
  font-weight: 600;
  line-height: 2.6rem;
  text-align: center;
  color: ${({ theme }) => theme.styleGuide.colors.gray[700]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
    line-height: 1.8rem;
  `}
`;
